let domain = 'www.subpop.com';

function getMainInfo(handle) {
  $.ajax({
    dataType: 'text',
    url: "https://" + domain + "/releases/" + handle + "/main_info.json",
    success:function(release) {
      var response = $.parseJSON(release);

      if (release != null) {
        $(".tracks").show();
        drawTracks(response.release.tracks)
      }
    },
    error:function() {
      //alert("Could not load the release description");
    }
  });
}

function drawTracks(tracks) {
  $(".tracks").empty();
  var tracksDiv = "<div id=\"tracklist\"><h3>Tracklist</h3><ul class=\'release-tracks'\">";

  tracks.forEach((track, index) => {
    var trackLi = "<li class=\"release-track\">" + (index + 1) + ". " + track.name + "</li>";
    tracksDiv = tracksDiv + trackLi;
  });
  tracksDiv = tracksDiv + "</ul>";
  $(".tracks").append(tracksDiv);
}

$(document).ready(function() {

  // This function adjusts the position of the tracks based on the window width
  // If the window is less than 768px wide, the tracks are moved below the description
  // Otherwise, the tracks are moved back to their original position just below the photo gallery
  function adjustTracksPosition() {
    if ($(window).width() < 768) { // Mobile view
      $('.tracks').appendTo('.grid__item.post-large--one-half:last'); // Move tracks below description
    } else { // Desktop view
      $('.tracks').appendTo('.gallery'); // Move tracks back to original position
    }
  }

  // Initial check
  adjustTracksPosition();

  // Listen for window resize events
  $(window).resize(function() {
    adjustTracksPosition();
  });
});